module.exports = __webpack_public_path__ + "img/5.b775a935.jpg";